<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
        <div>
          <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>
            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
              <div class="p-4">
                <p>
                  Lista de pedidos de socios de negocio. 
                  Muestra estados, fechas y totales; permite exportar.
                  Úsalo para seguimiento diario y para responder consultas
                  de clientes.
                </p>
              </div>
            </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
                Pedidos
            </h2>
          </div>
            <div class="text-sm text-secondary font-medium tracking-tight">
                Visualiza y exporta los <b>pedidos</b> de los <b>socios de negocio</b> por <b>material</b>.
            </div>
        </div>
        <!-- Header -->
        <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex shrink-0">
                <!-- Title -->
                <!--<div class="text-3xl font-extrabold tracking-tight">Pedidos</div> -->
                <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
                  [selectedCustomerType]="selectedCustomerType" [showStatus]="[StatusEnum.ACTIVE, StatusEnum.INACTIVE, StatusEnum.ORDER_IN_PROGRESS, StatusEnum.ORDER_APPROVED, StatusEnum.ORDER_REJECTED, StatusEnum.ORDER_PARTIAL_APPROVED]"
                  [showERPStatus]="[OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_CREATED, OrderStatusERPEnum.ORDER_ERROR, OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_ERROR_ERP]" 
                  [showCustomerType]="['BPT9002', 'BPT9001', 'BPT0001']"
                  (selectionFilterApply)="getListReport()">
                </app-status-filters>
            </div>
            <!-- Actions -->
            <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                <!-- <button mat-stroked-button color="primary" (click)="sidenav.toggle()" matTooltip="Mostrar filtros">
                    <mat-icon svgIcon="filter_list"></mat-icon>
                    <span>Filtrar por</span>
                </button> -->
                <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                    <span class="ml-2">Exportar</span>
                </button>
            </div>
        </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2">
      <div class="pt-1 mx-6">
        <!-- Smart Grid with horizontal scroll -->
        <div class="overflow-x-auto">
          <app-smart-grid
            [data]="dataSource.data"
            [columnDefs]="columnDefs"
            [config]="gridConfig"
            [loading]="false"
            [totalRecords]="totalItems"
            (gridReady)="onGridReady($event)"
            (pageChanged)="onPageChanged($event)"
            (sortChanged)="onSortChanged($event)">
          </app-smart-grid>
        </div>
      </div>
    </div>
  </div>


    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
  
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true"
        [showEndTrip]="true" [showUploadDateRange]="true" [showDeliveryDate]="true"></app-dates-filters>
    </app-filter-section>
  
    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
        [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>
  
    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
      <app-documents-filters [form]="form" [documentClass]="true" [typeDocumentClass]="type"
      [loadData]="loadDocumentsData"></app-documents-filters>
    </app-filter-section>
  
    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>
  
    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
        [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>
  
    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
      <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
      [loadData]="loadMaterialsData">
      </app-materials-management-filters>
    </app-filter-section>
  </app-filter>

  <mat-sidenav
    #sidenav
    mode="side"
    position="end"
    class="mat-sidenav-content p-0"
    closed
  >
    <div class="flex items-center justify-between bg-blue-950 text-white p-4">
      <mat-icon
        svgIcon="filter_list"
        class="text-white mr-2 w-4 h-4"
      ></mat-icon>
      <h2 class="text-current text-lg font-bold">Filtros</h2>
      <button
        mat-icon-button
        class="ml-auto"
        (click)="sidenav.close()"
        matTooltip="Cerrar"
      >
        <mat-icon
          class="text-current"
          [svgIcon]="'heroicons_outline:x-mark'"
        ></mat-icon>
      </button>
    </div>

    <div class="mt-6 px-4">
      <hr class="m-2" />
      <mat-form-field class="w-full">
        <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input
            matStartDate
            formControlName="start"
            placeholder="Fecha Inicio"
          />
          <input matEndDate formControlName="end" placeholder="Fecha Fin" />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <hr class="m-2" />
      <mat-form-field appearance="fill" class="w-full">
        <mat-label for="group-select" class="block text-gray-700"
          >Almacenes</mat-label
        >
        <mat-select
          [(ngModel)]="filter.warehouseId"
          (selectionChange)="changeWarehouse($event.value)"
          placeholder="Seleccione"
        >
          <mat-option>
            <ngx-mat-select-search
              [(ngModel)]="searchWarehouse"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="changueOptionsWarehouse($event)"
              placeholderLabel="Buscar..."
              noEntriesFoundLabel="No se encontraron resultados"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let warehouse of warehouseFilterList"
            [value]="warehouse.id"
          >
            <span *ngIf="getCode(warehouse) as code">{{ code }} - </span>
            {{ warehouse.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <hr class="m-2" />
      <mat-form-field appearance="fill" class="w-full">
        <mat-label class="block text-gray-700">Rutas</mat-label>
        <mat-select name="subRouteId" [(ngModel)]="filter.routes" multiple>
          <mat-option>
            <ngx-mat-select-search
              [(ngModel)]="searchSubRoute"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="changueOptionsSubRoute($event)"
              placeholderLabel="Buscar..."
              noEntriesFoundLabel="No se encontraron resultados"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let function of listFilterSubRouteList"
            [value]="function.id"
          >
            <b *ngIf="getCode(function) as code">{{ code }} - </b>
            {{ function.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="w-full mb-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label class="block text-gray-700">Material</mat-label>
          <mat-select [(ngModel)]="filter.item" name="item" multiple>
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="searchMaterial"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="changueOptionsMaterial($event)"
                placeholderLabel="Buscar material..."
                noEntriesFoundLabel="No se encontraron resultados"
              >
              </ngx-mat-select-search>
            </mat-option>
            @for (item of materialList; track item) {
              <mat-option [value]="item.code">
                <b>{{ item.code }}</b> - {{ item.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full mb-4">
        <mat-form-field appearance="fill" class="modal-input w-full">
          <mat-label class="block text-gray-700">Clase de Documento</mat-label>
          <mat-select
            [(ngModel)]="selectedDocumentClass"
            name="selectedDocumentClass"
            [multiple]="true"
            placeholder="Seleccione Clase de Documento"
            (selectionChange)="onDocumentClassSelectionChange($event.value)"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="documentClassMultiFilterCtrl"
                [showToggleAllCheckbox]="true"
                [toggleAllCheckboxIndeterminate]="isIndeterminateDocumentClass"
                [toggleAllCheckboxChecked]="isCheckedDocumentClass"
                [noEntriesFoundLabel]="'No se encontraron resultados'"
                [placeholderLabel]="'Buscar clase de documento...'"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let documentClass of filteredDocumentClasses | async"
              [value]="documentClass.code"
            >
              {{ documentClass.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <hr class="m-2" />

      <div class="w-full mb-4">
        <mat-form-field appearance="fill" class="modal-input w-full">
          <mat-label class="block text-gray-700">Vendedor</mat-label>
          <mat-select [(ngModel)]="selectedSeller">
            <mat-option [value]="'0'">Todos</mat-option>
            <mat-option
              *ngFor="let seller of sellerList"
              [value]="seller.username"
              >{{ seller.username }} - {{ seller.first_name }}
              {{ seller.last_name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full mb-4">
        <mat-form-field appearance="fill" class="modal-input w-full">
          <mat-label class="block text-gray-700">Pagador</mat-label>
          <input
            type="text"
            placeholder="Selecciona Pagador"
            aria-label="Selecciona pagador"
            matInput
            [formControl]="soldToControl"
            [matAutocomplete]="autoSoldTo"
          />
          <mat-autocomplete
            #autoSoldTo="matAutocomplete"
            [displayWith]="fetchSoldToName"
            (optionSelected)="onChangeSoldTo()"
          >
            @for (soldTo of soldToList; track soldTo) {
              <mat-option [value]="soldTo.id" class="text-content">
                {{ soldTo.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="w-full mb-4">
        <mat-form-field appearance="fill" class="modal-input w-full">
          <mat-label class="block text-gray-700">Receptor</mat-label>
          <input
            type="text"
            placeholder="Selecciona Receptor"
            aria-label="Selecciona Receptor"
            matInput
            [formControl]="shipToControl"
            [matAutocomplete]="autoShipTo"
          />
          <mat-autocomplete
            #autoShipTo="matAutocomplete"
            [displayWith]="fetchShipToName"
          >
            @for (shipTo of shipToList; track shipTo) {
              <mat-option [value]="shipTo.id" class="text-content">
                {{ shipTo.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <hr class="m-2" />
    </div>

    <div class="flex justify-between mt-4 px-4">
      <button
        mat-button
        class="align-left text-gray-700 border border-gray-300"
        (click)="onClearFilter()"
      >
        Limpiar
      </button>
      <button
        mat-raised-button
        class="ml-auto bg-blue-950 text-white"
        (click)="onFilter()"
      >
        Aplicar
      </button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>